import type { nftSchema } from "../../../api/schemas";
import { sameAddress } from "../../../state/model-helpers";

type NftDetail = ReturnType<typeof nftSchema.parse>;
type ExpectedDetail = {
  tokenId: string | null;
  chainId: number;
  collection: string;
  sourceToken: string;
  account: string;
};

/** Shared API eligibility checks; contract reads still decide the current quote. */
export function assertRedeemNftDetail(detail: NftDetail, expected: ExpectedDetail): void {
  const mismatch = (field: string, actual: string | number | null | undefined, wanted: string | number | null) => {
    throw new Error(`NFT detail mismatch: ${field} is ${actual ?? "unavailable"}; expected ${wanted}.`);
  };
  if (detail.tokenId !== expected.tokenId) mismatch("tokenId", detail.tokenId, expected.tokenId);
  if (detail.chainId !== expected.chainId) mismatch("chainId", detail.chainId, expected.chainId);
  if (!sameAddress(detail.collectionAddress, expected.collection)) mismatch("collectionAddress", detail.collectionAddress, expected.collection);
  if (!sameAddress(detail.sourceToken, expected.sourceToken)) mismatch("sourceToken", detail.sourceToken, expected.sourceToken);
  if (detail.dataStatus !== "CURRENT") {
    throw new Error(`NFT read is ${detail.dataStatus}; CURRENT is required before redemption.`);
  }
  if (detail.status !== "FINALIZED") {
    throw new Error(`NFT status is ${detail.status}; FINALIZED is required before redemption.`);
  }
  if (!sameAddress(detail.owner, expected.account)) {
    throw new Error(`UnauthorizedRedeemer: NFT owner is ${detail.owner ?? "unavailable"}; connected wallet is ${expected.account}.`);
  }
}
